import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {PREDICTION_WIDGET} from "../predictions-widget.consts";
import type {PredictionsWidgetState} from "../models/predictions-widget.state";
import {PredictionWidgetMainCardsModel} from "../models/cards/prediction-widget.main-cards.model";
import {PredictionWidgetPropsCardsModel} from "../models/cards/prediction-widget.props-cards.model";

export class PredictionWidgetTabChangeHandler extends ActionHandler {
  state: PredictionsWidgetState;
  type: String = PREDICTION_WIDGET.ACTION_TYPES.tabChange

  static injectables = [...ActionHandler.injectables];

  action(params) {
    this.state.tabIndex = params.index;

    if (this.state.isPredictionTabsVisible) {
      this.state.currentContext = new PredictionWidgetMainCardsModel(this.state.predictions, 0)
    } else if (this.state.isPropsTabsVisible) {
      this.state.currentContext = new PredictionWidgetPropsCardsModel(this.state.playersBetsPredictions, 0)
    }
  }
}


